import { useEffect } from "react";

export default function useReveal() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in");
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal, .draw-path").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
